import React from 'react';
import {
    AccountCircleOutlined, 
    Smartphone, 
    MailOutline, 
    PictureAsPdfOutlined, 
    CalendarToday, 
    DeleteOutline,
    MonetizationOnOutlined,
    Edit,
} from '@material-ui/icons';

export const helps_en = [
    {
        "titolo": "dashboard",
        "titoli_sezioni": [
            "Dashboard"
        ],
        "sezioni": [
            "The <b>Dashboard page</b> shows the menu with <b>all Hdemia sections</b>, on the left. By clicking on this icon ##0##, on the upper right side of the screen, it also shows other features:<br/><br/>• Account;<br/>• Payments;<br/>• Support;<br/>• Log out.<br/>"
        ], 
        "immagini": [
            [
                <AccountCircleOutlined />
            ]
        ]
    }, 
    {
        "titolo": "usersettings",                            
        "titoli_sezioni": [
            "Account Settings",         
        ], 
        "sezioni": [
            "In this Section you can easily <b>change your Password</b>. You will only need to enter the current Password and the new one. Confirm the Password you have chosen before updating it via specific button \"Aggiorna Password\""
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "account", 
        "titoli_sezioni": [
            "Account and Payments",
       ], 
        "sezioni": [
            "In this section you can take a look at <b>your current Plan and change your offer</b>. You can find all the information about <b>what is included in the different Plans</b>: Free, Premium and Custom.",
       ], 
       "immagini": [[]]
   },
   {
        "titolo": "sendFeedback", 
        "titoli_sezioni": [
            "Support",
        ], 
        "sezioni": [
            "If you need support or you are having problems with Hdemia, you can <b>easily ask for a ticket</> in the <b>Support Section</b>. You can look for a specific ticket by using the \"Cerca\" feature or directly from the list.",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "corsi", 
        "titoli_sezioni": [
            "Add a New Course",
            "Course Info", 
	        "Quick actions using table icons"
        ], 
        "sezioni": [
            "To <b>add a new course</b> you will need to click on the button on the top right <b>\"Nuovo\"</b>. It will then be possible to enter the name of the new course, its duration and the academic year.",
            "To obtain and edit information about a course, it is necessary to click on the reference line.", 
	        "Quick Actions will allow you to: <br/>• Send a notification  ##0## to the App of those participating in the course.;<br/>• Send an email ##1## to course participants;<br/>•Generate a PDF ##2## by selecting a date range for calculation;<br/>• Access the calendar function to enter new classes (online classes, as well) for the day and time you prefer. ##3##;<br/>• Delete the course ##4## from the list."
        ], 
        "immagini": [
            [],
            [], 
            [<Smartphone />, <MailOutline />, <PictureAsPdfOutlined />, <CalendarToday />, <DeleteOutline />]
        ]
   },
   {
        "titolo": "editCorso", 
        "titoli_sezioni": [
            "Course's Details",
        ], 
        "sezioni": [
            "In the <b>“Course's Deatils”</b> Section, it is possible to add <b>all the information about the selected course</b>. Enter the name of the class in the specific box, add its duration and academic year. The <b>“Lessons' billing division”</b> option assigns lesson hours to all teachers registered for that lesson - for example: one hour lesson with two teachers: 30 minutes billed each. It is possible to consult the <b> students list </b> for the course in the Section below <b>\"Student list\"</b>. Here, you can quickly view student data, absentee rate and exams information. With this list, you can set up the selected student as \"Withdrawn\" ##0##, or generate a PDF ##1## with a summary of the exams taken by the student for that course. You can print the course averages by clicking the button on the right \"Print Course Averages\" <br/> <br/> ##2## <br/> <br/> You can view the <b>exams calendar</b> for the selected course and add new ones using the \"Add\" button <br/> <br/> ##3## <br/> <br/>More specifically, the table shows the dates of the exams, the subject of reference, the teacher, the notes and the type of exam (oral or written). For each exam you can generate a PDF ##4## which <b>shows the names of the students and their grades</b>. You can also delete that exam from the ##5## list."
        ], 
        "immagini": [
            [               
                <img src={ require('../images/remove-user.png') } style={{ width: 15, height: 15, objectFit: 'contain', textAlign: 'center' }} />,
                <PictureAsPdfOutlined />, 
                <img src={ require('../images/stampa_medie.png') } style={{ width: '100%', height: 50, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/aggiungi.png') } style={{ width: '100%', height: 50, objectFit: 'contain', textAlign: 'center' }} />,
                <PictureAsPdfOutlined />,
                <DeleteOutline />
            ]
        ]
    },
    {
        "titolo": "studenti", 
        "titoli_sezioni": [
            "Adding a new student",
            "View Student Information", 
	        "Quick actions using table icons"
        ], 
        "sezioni": [
            "To <b>add a new student</b> click on the button on the top right <b>\"Add\"</b>. Then enter all the student's data and assign the student to the reference course.",
            "Click on a student's line to <b>view their information</b>. Once clicked, you will be able to edit or consult the data.", 
	        "For each Student it is possible to use the icons in the table to carry out quick actions: <br/>• Send a notification directly to the student's App ##0##; <br/>• Send an email to the student ##1##; <br/>• For each student, you can generate a PDF ##2## with the details of the exams taken and overall average; <br/>• Delete a student from the list ##3##."
        ], 
        "immagini": [
            [],
            [],
            [<Smartphone />, <MailOutline />, <PictureAsPdfOutlined />, <DeleteOutline />]
        ]
   },
   {
        "titolo": "editStudente", 
        "titoli_sezioni": [
            "Edit Student",
        ], 
        "sezioni": [
            "In the <b>\"Edit Student\"</b> Section it is possible to edit all the information of the signle student, in a fast and easy way. Furthermore, by clicking on the <b>\"Send user credentials\"</b> button you can send the credentials to the selected student so that they can <b>access Hdemia</b> via Mobile App or Web.",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "insegnanti", 
        "titoli_sezioni": [
            "Add a new teacher",
            "View teacher information", 
	        "Quick actions using table icons",
            "PDF and Excel files generation for turnover reports"
        ], 
        "sezioni": [
            "To <b>add a teacher to the system</b> you need to click on the specific button at the top right <b>\"Add\"</b>, you can then enter all the information.",
            "To <b>view information</b> click on a teacher's line. Once clicked, you will be able to edit or consult the data.", 
	        "For each Teacher it is possible to use the icons in the table to carry out quick actions: <br/> •Send a notification directly to the Teacher's App ##0##; <br/> •Send an email to the teacher ##1##; <br/>• Generate a PDF ##2## by selecting a date range for the calculation of the document; <br/>• Consult the billing data ##3## in order to view the hours to be invoiced to the selected teacher; <br/>• Delete a teacher from the list ##4##.",
            "Via two buttons at the top <b>\"Generate PDF\"</b> and <b>\"Generate Excel\"</b> it is possible to download <b>turnover reports</b> by entering a period interval - example 09/2021. <br/> <br/> ##0##" 
        ], 
        "immagini": [
            [],
            [],
            [<Smartphone />, <MailOutline />, <PictureAsPdfOutlined />, <MonetizationOnOutlined />, <DeleteOutline />],
            [
                <img src={ require('../images/pdf_excel.png') } style={{ width: '100%', height: 50, objectFit: 'contain', textAlign: 'center' }} />,
            ]
        ]
   },
   {
        "titolo": "editInsegnante", 
        "titoli_sezioni": [
            "Edit Teacher",
        ], 
            "sezioni": [
                "In the <b>\"Edit Teacher\"</b> Section it is possible to edit all the information of the individual teacher, in a fast and easy way. Furthermore, by clicking on the <b>\"Send user credentials\"</b> button you can send the credentials to the selected teacher so that they can <b>access Hdemia</b> via Mobile App or Web.",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "aule", 
        "titoli_sezioni": [
            "Adding a new Classroom",
            "Quick actions using table icons", 
        ], 
        "sezioni": [
            "To <b>add a new classroom</b>, click on the specific button at the top right <b>\"Add\"</b>. It will then be possible to enter the name of the classroom and its capacity",
            "For each classroom it is possible to carry out quick actions using the icons shown in the table: <br/>• Generate a PDF ##0## by selecting a range of dates for the calculation of the document; <br/>• Access the calendar function ##1##. Select a date range for the desired calculation; <br/>• Delete a classroom from the list ##2##.", 
        ], 
        "immagini": [
            [],
            [<PictureAsPdfOutlined />, <CalendarToday />, <DeleteOutline />]
        ]
   },
   {
        "titolo": "notifiche", 
        "titoli_sezioni": [
            "Notifications",
        ], 
        "sezioni": [
            "In the <b>\"Notifications\"</b> Section you will find all the <b>notifications that have been sent</b> by the Hdemia management system to the users mobile App",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "scuola", 
        "titoli_sezioni": [
            "School Holidays",
    
        ], 
        "sezioni": [
            "Use the specific calendar to <b>set the closing days</b> of your school. Click on a date to add a school holiday, click again to remove it.",
        ], 
        "immagini": []
   },
   {
        "titolo": "cestinoCorsi", 
        "titoli_sezioni": [
            "Deleted Courses",
        "Delete a course permanently", 
        ], 
        "sezioni": [
            "In the  <b>\"Deleted Courses\"</b> Section you will find all the deleted courses. By clicking on the single course it is possible to <b>view its information</b>.",
            "By clicking on the ##0## icon on the line of the single deleted course, you can <b>permanently delete it</b>. <b>Courses deleted in this way can no longer be retrieved.</b>.",
        ], 
        "immagini": [
            [], 
            [<DeleteOutline />]
        ]
    },
    {
        "titolo": "adminSettings", 
        "titoli_sezioni": [
            "Settings",
            "Email Sending Settings", 
	        "Web & Mobile App Customization"
        ], 
        "sezioni": [
            "<b>By uploading and setting the Logo of your school you can customize the System and the generated PDF documents, automatically</b>. For the Mobile App it is possible to choose <b>an image or a background color</b> so as to standardize the app to your School - it is preferable that the chosen image has a height greater than the width. To set the desired color, simply click in the specific section <b>Mobile App Menu Background</b>: <br/> <br/>##0##<br/> <br/>Alternatively, if you want to <b>add an image</b> just click on the select button and choose from the options proposed by Hdemia or upload a file from your computer by clicking here: <br/> <br/>##1##<br/> <br>You can <b>upload your School's logo</b> by clicking on the specific button below \"Logo\": <br/> <br/> ##2##",
            "By filling in the sections below <b>Email Sending Settings</b> you can send emails to students and teachers. Enter the <b>email address from which you want to send messages</b> and the <b>name that will appear to the recipients</b>. Please, remember to check the e-mail address you entered.",
            "With <b>Web & Mobile App Customization</b> you can edit the colors and the menu of Hdemia Mobile App in order to match the image of your school. <br/> <b><i> NB: users will have to close and reopen the app to view the changes</i></b>. <br/>Choose the main and the secondary color by clicking in the appropriate sections: <br/><br/>##0## ##1##<br/> <br/>##2##<br/> <br/>Also, via <b>\"Sections of the Mobile App Menu\"</b> you can decide the sections that will be available to the users. <br/> <br/>##3##<br/> <br/>You can also <b> customize the color of the texts in the mobile menu</b> using the specific button:<br/><br/>##4##"
        ], 
        "immagini": [
            [
                <img src={ require('../images/help_1.png') } style={{ width: '100%', height: 100, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/help_2.png') } style={{ width: '100%', height: 100, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/help_3.png') } style={{ width: '100%', height: 100, objectFit: 'contain', textAlign: 'center' }} />
            ], 
            [], 
            [
                <img src={ require('../images/primario.png') } style={{ width: '50%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/secondario.png') } style={{ width: '50%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/colori.png') } style={{ width: '100%', height: 150, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/sezioni.png') } style={{ width: '100%', height: 150, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/colore_testo.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />
            ]
        ]
    },
    {
        "titolo": "users", 
        "titoli_sezioni": [
            "Add a new user",
            "Managing Users"
        ], 
        "sezioni": [
            "To <b>add a new user</b> simply click on the button at the top right ”<b>Add</b>”. Create a new user by entering the information and privileges: determine whether the user will be an <b>administrator<b/> or <b>billing</b> user. <br/> <br/> •<b>Administrator Account</b>: can edit courses, students and any other settings of the School in the system. In addition, this type of user has access to all billing information. <br/> <br/> •<b>Billing Account</b>: this account can only access and edit installments and billing information. This user is not allowed to access or view information regarding courses, students, etc.<br/> <br/>For each account you want to add, you must enter the e-mail and password.",
            "You can view the users of the management software directly from the table. For each user you can see their <b>username</b> and <b>type</b (Administrator or Billing). It is also possible to delete a user by clicking on the ##0## icon in the reference line."
        ], 
        "immagini": [
            [], 
            [<DeleteOutline />]
        ]
   },
   {
        "titolo": "billing/corsi", 
        "titoli_sezioni": [
            "Course billing"
        ], 
        "sezioni": [
            "To view the <b>billing details of the single course</b>, simply click on the reference line and a panel of the selected course <b>installment plan</b> will open."
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/editCorso", 
        "titoli_sezioni": [
            "Course Installment Plan",
            "Student Installment Plan"
        ], 
        "sezioni": [
            "For each course it is possible to define the corresponding installment plan. To proceed, simply enter the cost for the individual student in the specific section: <br/> <br/>##0##<br/> <br/>• To <b>add an installment</b> it is necessary to click on the specific button. <br/> Set the date for the payment and enter the relative amount, this procedure must be repeated for each installment that you intend to add - example: if I intend to divide the cost of the course into 3 installments , I will have to click on the \"Add installment\" button 3 times. Each time by setting the date and the amount. In this case, I will therefore have a list with 3 installments. <br/>Before completing the procedure, please remember to <b>save the installment plan</b> by clicking on the specific button<br/><br/>##1##",
            "At the bottom of the Course Installment Plan page, a table appears with the <b>names of the students, their installment plan and payment percentage</b>. To <b>view the details</b>, click on the line of the selected student."
       ], 
       "immagini": [
           [
                <img src={ require('../images/agg_rata.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/salva_rate.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
           ], 
           [] 
       ]
   },
   {
        "titolo": "billing/editStudente", 
        "titoli_sezioni": [
            "Student Installment Plan",
        ], 
        "sezioni": [
            "In this section it is possible to <b>view and edit the data relating to the installment plan of the individual student</b>. You can easily consult paid amounts and those to be paid by the selected student. It is possible to consult the total cost per student and <b>add a new installment</b> - set the date, the amount and status of the installment (<b>unpaid, to be verified, paid</b>) - if necessary. <br/>You can easily view the list of installments that make up the student's plan and, if necessary, delete them using the specific icon ##0##",
        ], 
        "immagini": [
            [<DeleteOutline color="red" />]
        ]
    },
    {
        "titolo": "billing/studenti", 
        "titoli_sezioni": [
            "Student Invoices"
        ], 
        "sezioni": [
            "You can easily <b>consult the list of students</b> and click on the line of the selected student to <b>view the installment data associated with that student</b>. <br/>In addition, you can download the billing data of the academic years and obtain the corresponding Excel document. Just select the academic year you need and click on the specific button <b>\"Generate Excel\"</b><br/><br/>##0##",
        ], 
        "immagini": [
            [
                <img src={ require('../images/anno_acc.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />
            ]
        ]
   },
   {
        "titolo": "billing/studenteDetails", 
        "titoli_sezioni": [
            "Student Installments"
        ], 
        "sezioni": [
            "In this section it is possible to quickly view the <b>installments of the selected student</b>. For each installment, it is shown the date, the amount, the payment status and whether the electronic invoice was sent. <br/>To make <b>changes to the student's installment plan</b> just click on the icon next to the course name. ##0##"
        ], 
        "immagini": [
            [<Edit />]
        ]
    },
    {
        "titolo": "billing/ritirati", 
        "titoli_sezioni": [
            "Withdrawn Students",
        ], 
        "sezioni": [
            "In the <b>Withdrawn Students</b> Section it is possible to consult the list of students who no longer attend the courses. To get <b>more information</b> about the installment plan of the withdrawn student, just <b>click on the reference line</b>. ",
        ], 
        "immagini": [[]]
   },
   {
        "titolo": "billing/daVerificare", 
        "titoli_sezioni": [
            "Payments to be Verified"
        ], 
        "sezioni": [
            "In this Section you can view the <b>payments to be verified</b>. In fact, the table shows all the students' installment data: <br/> <br/> name, surname, course, date and amount."
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/inRitardo", 
        "titoli_sezioni": [
            "Viewing Overdue Payments"
        ], 
        "sezioni": [
            "In the <b>Overdue Payments</b> Section you can consult the <b>list of students who have overdue payments</b>. For each student, in fact, from the table it is possible to view the reference course, the date of the overdue payment and the its amount."
        ], 
        "immagini": [[]]
   },
   {
        "titolo": "billing/insegnanti", 
        "titoli_sezioni": [
            "Invoicing - Teachers"
        ], 
        "sezioni": [
            "In the <b>Teachers</b> section you can easily consult the list of all your teachers. By clicking on each teacher's line you will be able to access the <b>related data and billing documents</b>"       
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/fattureInsegnante", 
        "titoli_sezioni": [
            "Teacher Invoices"
        ], 
        "sezioni": [
            "In this Section you can consult the list of invoices for the selected teacher - with related dates, amounts, payment status and any notes. In addition, you can conveniently <b>add a new invoice</b> by clicking on the specific button on the top right <b>\"New\".</b> <br/> <br/> ##0## <br/> <br/>From here, you can <b>enter the invoice date, the amount, the status (unpaid or paid), add any notes and upload files to attach.</b>"
        ], 
        "immagini": [
            [
                <img src={ require('../images/nuova.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />
            ]
        ]
   },
   {
        "titolo": "billing/fattureInsegnanti", 
        "titoli_sezioni": [
            "Teacher Invoices"
        ], 
        "sezioni": [
            "In this Section you can quickly and easily consult the <b>list of teachers' invoices</b>. For each invoice, the name of the referring teacher, the date, the amount, the status and any notes are shown. In addition, <b>by clicking on the invoice of interest you can edit its data or delete it</b> - for example, change the amount or add a file."
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/electronicReceipts", 
        "titoli_sezioni": [
            "Electronic Invoicing",
            "PDF Electronic Invoice"
        ], 
        "sezioni": [
            "In the <b>Electronic Invoicing</b> Section, you can consult the list of students' electronic invoices. For each invoice, in fact, various data are shown - the number, the date, the amount, the name of the student with the Tax Code. ",
            "By clicking on the ##0## icon, for each invoice, it will be possible to view the official PDF document. The file includes all the data sent to the Income Revenue Authority system: <br/> <br/>supplier and customer data; document type and number; the motive; description, prices and VAT of the service; data summary; information about the payment method and its amount. "
        ], 
        "immagini": [
            [], 
            [
                <img src={ require('../images/pdf_bill.png') } style={{ width: 20, height: 20, objectFit: 'contain', textAlign: 'center' }} />,
            ]
        ]
   }

]